export default __webpack_public_path__ + "static/media/wikipedia.d28c4351.jpg";